
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, Clock, Phone } from "lucide-react";

const ContactInfo = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Mail className="h-5 w-5 text-godyspo-gold" />
            Get in Touch
          </CardTitle>
          <CardDescription>
            We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-3">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="font-medium">Email</p>
              <a 
                href="mailto:support@godyspo.com" 
                className="text-godyspo-gold hover:underline"
              >
                support@godyspo.com
              </a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="font-medium">Phone</p>
              <a 
                href="tel:+12489977335" 
                className="text-godyspo-gold hover:underline"
              >
                (248) 997-7335
              </a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="font-medium">Secondary Business Line</p>
              <a 
                href="tel:+13134232049" 
                className="text-godyspo-gold hover:underline"
              >
                (313) 423-2049
              </a>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Clock className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="font-medium">Response Time</p>
              <p className="text-muted-foreground">We'll get back to you within 24 hours</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactInfo;
